import { catchError, switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { googleOneTapLogin } from 'constants/routes'

/**
 * loginUserWithGoogleOneTap: this function returns a fromFetch observable. This observable is in charge of
 * posting user authentication information from Google One Tap to NewHomeSource so the page can sucessfully
 * authenticate an user coming from Google One Tap authentication widget.
 * @param {*} parameters a set of information retrieved from Google One Tap containing information used to
 * authenticate an user in NewHomeSource.
 * @returns 
 */
const loginUserWithGoogleOneTap = (parameters) => fromFetch(googleOneTapLogin, {
        method: 'POST',
        body: JSON.stringify(parameters),
        headers: {
            'Content-Type': 'application/json'
        }
    }).pipe(
        switchMap((response) => response.json()),
        catchError(() => {}),
      );

export default loginUserWithGoogleOneTap;